import {Component, Input, OnInit} from '@angular/core';
import {select} from '@angular-redux/store';
import {ActionsService} from '../../../../Redux/Actions/actions.service';
import {ApplicationSpecActions} from '../../../../Redux/Actions/application-spec-actions';
import {MatDialog} from '@angular/material/dialog';
import {FeatureEx} from '../../../../models/features/features';
import {FeatureFilterState, SIZE_BOTTOM_FEATURES, SIZE_TOP_FEATURES} from '../../../../models/features/feature_const';
import {tassign} from 'app/common/utils';

@Component({
  selector: 'edsng-features-recap',
  templateUrl: './features-recap.component.html',
  styleUrls: ['./features-recap.component.css']
})
export class FeaturesRecapViewComponent implements OnInit {
  /**
   * Booleano se deve essere presente lo scroll nell'elenco delle features
   */
  @Input() withScroll: boolean = false;

  @select(['appSpec', 'featuresFilter'])  featuresFilter$;

  topFeatures: FeatureEx[];
  bottomFeatures: FeatureEx[];
  fullFeatures: FeatureEx[];
  featureList: FeatureEx[] = [];

  constructor(public dialog: MatDialog, private actSrvc: ActionsService) {
  }

  ngOnInit() {
    this.featuresFilter$.subscribe(x => {
      this.featureList = x.filter( (f) => f.stateFilter !== 0 && !f.isCommon );
      this.fullFeatures = x;
      this.topFeatures = x.slice(0, SIZE_TOP_FEATURES);
      this.bottomFeatures = x
        .slice(SIZE_TOP_FEATURES)
        .filter( ({stateFilter}) => stateFilter !== 0)
        .slice(0, SIZE_BOTTOM_FEATURES);
    });
  }

  updateFilterFeature(feature: FeatureEx) {
    this.actSrvc.sendAction(ApplicationSpecActions.updateFeature(feature));
  }

  /**
   * Utilizzata quando viene selezionato il NO_FILTER
   * @param f feature
   */
  deselectFeature(f) {
    const featEx: FeatureEx = tassign(f, {
      stateFilter: FeatureFilterState.NO_FILTER
    });
    this.actSrvc.sendAction(ApplicationSpecActions.updateFeature(featEx));
  }

}
